export default {
  black: 'hsl(0, 0%, 11%)',
  white: 'hsl(0, 0%, 100%)',
  semiDark: 'hsl(0, 0%, 26%)',
};
